import { AppDownloadScreen } from './appDownloadScreen.js';

const props = [];

export const AppDownloadScreenDirective = reactDirective => reactDirective(AppDownloadScreen, props);
AppDownloadScreenDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('appDownloadScreen', AppDownloadScreenDirective);
